import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import { headersWithAuthWithoutBody } from "../APIHelpers/Responses";

export const userDashboardServices = {
  getUserDashboardSummary,
};

async function getUserDashboardSummary() {
  const response = await fetch(
    `${config.API_URL}getUserDashboardSummary`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
